import { useEffect, useState } from "react";
import ListCity from "../../components/cities/list-cities/ListCities";
import PageBar from "../../components/dashboard/page-bar/PageBar";
import ListState from "../../components/states/list-states/ListState";
import axios from "axios";
import { deleteApiCity } from "../../components/apifile/ApiFiles";
import { Loaders } from "../Loaders";

function ListCitiesPage() {
  const [loader, setLoader] = useState(false)
  const [data, setData] = useState();
  const [count, setCount] = useState(10)
  const [page, setPage] = useState(1)

  const [initialVlue, setInitialVlue] = useState({
    search: '',
  })
  const handleChange = (e) => {
    const clone = { ...initialVlue }
    const value = e.target.value
    const name = e.target.name
    clone[name] = value
    setInitialVlue(clone)
  }
  const getCitiesData = async (page) => {
    setLoader(true)
    const clone = { ...initialVlue, page: page, count: count }
    try {
      const res = await axios.get(
        `https://abarishr.hennainternational.in/api/cities/all?count=${clone?.count}&page=${clone?.page}&search=${clone?.search}`
      );
      // console.log(res?.data);

      setData(res?.data);
      setLoader(false)
    } catch (error) { setLoader(false) }
  };
  const reset = async (page) => {
    setLoader(true)
    const clone = { search: '', page: page, count: count }
    try {
      const res = await axios.get(
        `https://abarishr.hennainternational.in/api/cities/all?count=${clone?.count}&page=${clone?.page}&search=${clone?.search}`
      );
      setData(res?.data);
      setInitialVlue({
        search: '',
      })
      setLoader(false)
    } catch (error) { setLoader(false) }
  }

  useEffect(() => {
    getCitiesData(1);
  }, []);

  // const getCitiesData2 = async (page) => {
  //   try {
  //     const res = await axios.get(
  //       `https://abarishr.hennainternational.in/api/cities/all?page=${page}`
  //     );
  //     setData(res.data);
  //   } catch (error) {
  //     alert("Error");
  //   }
  // };

  const handleDelete = async (id) => {
    try {
      const res = await deleteApiCity(id);
      getCitiesData(1)
    } catch (error) {
      alert("Error");
    }
  };
  const onChangeVal = (e) => {
    // console.log(e);
    getCitiesData(e)

  };

  return (
    <>
      {loader && <Loaders />}
      <div className="pageWrapper">
        <PageBar title=" Cities" />
        <h3 className="page-title">
          Manage Cities
        </h3>
        <ListCity data={data} handleDelete={handleDelete} getCitiesData={getCitiesData} onChangeVal={onChangeVal} initialVlue={initialVlue} handleChange={handleChange} reset={reset} />
      </div>
    </>
  );
}
export default ListCitiesPage;
